// Avatar background colors - using blue and green color variations
const avatarColors = [
  "bg-blue-400",
  "bg-blue-500",
  "bg-blue-600",
  "bg-blue-700",
  "bg-sky-500",
  "bg-sky-600",
  "bg-cyan-500",
  "bg-cyan-600",
  "bg-green-400",
  "bg-green-500",
  "bg-green-600",
  "bg-green-700",
  "bg-emerald-500",
  "bg-emerald-600",
  "bg-teal-500",
  "bg-teal-600",
]

/**
 * Generates initials from a full name
 * - Single name: Returns first letter
 * - Two names: Returns first and second initials
 * - Three or more names: Returns first and third initials
 */
export function getInitials(name: string): string {
  if (!name || typeof name !== "string") {
    return "?"
  }

  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0)

  if (words.length === 0) {
    return "?"
  }

  if (words.length === 1) {
    return words[0][0].toUpperCase()
  }

  if (words.length === 2) {
    return (words[0][0] + words[1][0]).toUpperCase()
  }

  // For 3 or more names, use first and third initials
  return (words[0][0] + words[2][0]).toUpperCase()
}

/**
 * Generates a consistent background color for an avatar based on the name
 */
export function getAvatarColor(name: string): string {
  if (!name || typeof name !== "string") {
    return avatarColors[0]
  }

  // Create a simple hash from the name
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32-bit integer
  }

  // Use absolute value and modulo to get a valid index
  const index = Math.abs(hash) % avatarColors.length
  return avatarColors[index]
}

/**
 * Generates avatar props (initials and color) for a given name
 */
export function getAvatarProps(name: string) {
  return {
    initials: getInitials(name),
    color: getAvatarColor(name),
  }
}
